import { useEffect } from 'react';
import { collection, query, orderBy, onSnapshot, where, Timestamp } from 'firebase/firestore';
import { db } from '../../config/firebaseConfig';

const AdminNotificationListener = () => {
    useEffect(() => {
        // Only run if admin is logged in
        const isAdminLoggedIn = localStorage.getItem('adminLoggedIn') === 'true';
        if (!isAdminLoggedIn) return;

        console.log('🔔 Admin Notification Listener Active');

        // We only want to notify about orders created AFTER the listener started
        const startTime = Timestamp.now();

        const ordersRef = collection(db, 'orders');
        const q = query(
            ordersRef,
            where('createdAt', '>', startTime),
            orderBy('createdAt', 'desc')
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            snapshot.docChanges().forEach((change) => {
                if (change.type === 'added') {
                    const orderData = change.doc.data();
                    const orderId = change.doc.id;

                    console.log('🛍️ New order detected!', orderId);

                    // Trigger browser notification
                    if ('Notification' in window && window.Notification.permission === 'granted') {
                        const customerName = orderData.customer?.fullName || orderData.customerData?.fullName || 'New Customer';
                        const total = orderData.total || 0;

                        const notification = new window.Notification('🛍️ WallZ: New Order!', {
                            body: `${customerName} placed an order for ${total} EGP`,
                            icon: '/logoPage.png',
                            tag: 'new-order-' + orderId,
                            requireInteraction: true
                        });

                        notification.onclick = () => {
                            window.focus();
                            window.location.href = '/admin/orders';
                        };

                        // Also play a sound if possible
                        try {
                            const audio = new Audio('https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3');
                            audio.play().catch(e => console.log('Audio play failed', e));
                        } catch (e) { }
                    }
                }
            });
        }, (error) => {
            console.error('Snapshot listener error:', error);
        });

        return () => unsubscribe();
    }, []);

    return null; // This component doesn't render anything
};

export default AdminNotificationListener;
